/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from './components/vx-card/VxCard.vue'
import VxList from './components/vx-list/VxList.vue'
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon from './components/FeatherIcon.vue'
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue'
import App from './components/global/app/App.vue'
import Header from './components/global/app/Header.vue'
import QuillEditor from './components/global/text-editor/QuillEditor.vue'
import Modal from './components/global/modal/Modal.vue'
import ModalSetting from './components/global/modal/ModalSetting.vue'
import UploaderButton from './components/global/uploader/UploaderButton.vue'
import UploaderItem from './components/global/uploader/UploaderItem.vue'
import FileUpload from './components/global/uploader/FileUpload.vue'
import InputTujuan from './components/global/input/InputTujuan.vue'
import InputRupiah from './components/global/input/InputRupiah.vue'
import Uploader from './components/global/uploader/Uploader.vue'
import Wrapper from './components/global/wrapper/Wrapper.vue'
import WrapperList from './components/global/wrapper/WrapperList.vue'
import Comment from './components/global/comment/Comment.vue'
import vSelect from 'vue-select'
import Skeleton from './components/global/loading/Skeleton.vue'
import User from './components/global/user/User.vue'
import InputDate from './components/global/input/InputDate.vue'
import GlobalTable from './components/global/table/Table.vue'
import GlobalTh from './components/global/table/Th.vue'
import GlobalTd from './components/global/table/Td.vue'
import GlobalTr from './components/global/table/Tr.vue'





Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('global-app', App)
Vue.component('global-header', Header)
Vue.component('global-modal', Modal)
Vue.component('global-quill-editor', QuillEditor)
Vue.component('global-modal-setting', ModalSetting)
Vue.component('global-uploader', Uploader)
Vue.component('global-uploader-button', UploaderButton)
Vue.component('global-uploader-item', UploaderItem)
Vue.component('global-file-upload', FileUpload)
Vue.component('global-wrapper', Wrapper)
Vue.component('global-wrapper-list', WrapperList)
Vue.component('global-skeleton', Skeleton)
Vue.component('global-comment', Comment)
Vue.component('global-user', User)
Vue.component('global-input-date', InputDate)
Vue.component('global-input-tujuan', InputTujuan)
Vue.component('global-input-rupiah', InputRupiah)
Vue.component('global-table', GlobalTable)
Vue.component('global-th', GlobalTh)
Vue.component('global-td', GlobalTd)
Vue.component('global-tr', GlobalTr)





// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
